/* Zayluna: Menge im Warenkorb wechselt zwischen den Paketen (1 / 2 / 3 Monats-Vorrat) statt die Stückzahl zu vervielfachen */
(function () {
  if (window.__cgCartBundles) return; window.__cgCartBundles = true;
  const GIFT = { 'Gratis-Zugabe': '1 Flasche gratis (4 Flaschen pro Paket)' };

  const post = async (url, body) => {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (!r.ok) throw new Error(url + ' ' + r.status);
    return r.json();
  };

  // n Monate -> Pakete: bis 3 genau ein Paket, darüber 3er-Pakete plus Rest
  const plan = (n, v) => {
    const lines = [];
    const push = (size, quantity) => lines.push(size === 3 ? { id: +v[3], quantity, properties: GIFT } : { id: +v[size], quantity });
    if (n <= 3) push(n, 1);
    else { push(3, Math.floor(n / 3)); if (n % 3) push(n % 3, 1); }
    return lines;
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('quantity-input[data-cg-months] .quantity__button');
    if (!btn) return;
    const qi = btn.closest('quantity-input'), cur = +qi.dataset.cgMonths, plus = btn.name === 'plus';
    const v = { 1: qi.dataset.cgV1, 2: qi.dataset.cgV2, 3: qi.dataset.cgV3 };
    if (!v[1] || !v[2] || !v[3]) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (qi.dataset.cgBusy) return;
    qi.dataset.cgBusy = '1'; qi.style.opacity = '.5'; qi.style.pointerEvents = 'none';

    const n = plus ? (cur >= 3 ? cur + 3 : cur + 1) : (cur > 3 ? cur - 3 : cur - 1);
    const drawer = qi.closest('cart-drawer');
    try {
      const sections = { sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
      const ziel = n > 0 ? plan(n, v) : [];

      /* ⛔ Gemessen am 23.09.2026: Jedes /cart/add.js lässt Shopify „product_added_to_cart" feuern,
         und die Meta-App meldet das als „In den Einkaufswagen" — auch beim Verringern der Menge.
         Vorher wurde hier bei JEDEM Klick die Zeile gelöscht und neu angelegt; dadurch stand im
         Werbeanzeigenmanager ein Vielfaches der echten Warenkörbe (23.09.: 61 Warenkörbe gegen
         47 Produktansichten). Bleibt die Variante dieselbe und ändert sich nur die Stückzahl,
         reicht /cart/change.js — das feuert kein Ereignis. Nur der echte Paketwechsel
         (1 ↔ 2 ↔ 3 Monate) braucht weiter löschen + neu anlegen, und dort ist ein
         Warenkorb-Ereignis auch inhaltlich richtig. */
      const varianteJetzt = String(qi.dataset.cgKey || '').split(':')[0];
      const nurMenge = ziel.length === 1 && String(ziel[0].id) === varianteJetzt;

      let state;
      if (nurMenge) {
        state = await post('/cart/change.js', Object.assign({ id: qi.dataset.cgKey, quantity: ziel[0].quantity }, sections));
      } else {
        state = await post('/cart/change.js', Object.assign({ id: qi.dataset.cgKey, quantity: 0 }, sections));
        if (n > 0) state = await post('/cart/add.js', Object.assign({ items: ziel }, sections));
      }

      if (drawer && n > 0 && typeof drawer.renderContents === 'function' && state.sections) drawer.renderContents(state);
      else location.reload();
    } catch (err) {
      console.error('[cg-cart-bundles]', err);
      location.reload();
    }
  }, true);
})();
